import { h } from "preact";

import StaticContainer from "../../components/StaticContainer/StaticContainer";

const selfClose = () => {
  window.isSelfClosed = true;
  window.close();
};
function CloseWindow(params) {
  // try closing immediately, if it fails, show a button to close
  selfClose();
  return (
    <StaticContainer>
      <button type="button" class="btn btn-primary mt16" onClick={selfClose}>
        Close
      </button>
    </StaticContainer>
  );
}

export default CloseWindow;



// WEBPACK FOOTER //
// ./routes/CloseWindow/index.jsx